export default __webpack_public_path__ + "static/media/013.47df360f.jpg";